<template>
	<div :key="componentInstanceId" class="flex items-start justify-between gap-2 lg:gap-4 max-lg:flex-col grow">
		<div class="grow">
			<div
				class="mb-1"
				:class="!selectedHypermarket && heading && 'flex md:items-center gap-1 md:gap-4 max-md:flex-col'"
			>
				<h1 v-if="!selectedHypermarket && heading" key="heading-no-hm" class="typo-h1">
					{{ heading }}
				</h1>
				<LazyInformationAboutHypermarket
					v-if="selectedHypermarket"
					:key="`selected-${componentInstanceId}-${selectedHypermarket}`"
					:show-links-in-selection-banner="showLinksInSelectionBanner"
					compact
				>
					<template #pageHeading>
						<h1 v-if="heading" class="typo-h1 inline-flex mr-2 lg:mr-4 mb-2">
							{{ heading }}
						</h1>
					</template>
				</LazyInformationAboutHypermarket>
			</div>
			<p v-if="subheading">
				{{ subheading }}
			</p>
		</div>
		<div v-if="!selectedHypermarket || $slots.aside" class="flex flex-col items-start lg:items-end justify-start gap-4">
			<div v-if="$slots.aside">
				<slot name="aside" />
			</div>
			<LazyInformationAboutHypermarket
				v-if="!selectedHypermarket"
				:key="`info-no-hm-${componentInstanceId}-${selectedHypermarket}`"
				:text="informationText"
				:default-hm="defaultHm"
				:show-links-in-selection-banner="showLinksInSelectionBanner"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
	import {storeToRefs} from 'pinia';
	import {useStoryblokHypermarketsStore} from '@/stores/storyblokHypermarkets';

	type Props = {
		heading: string;
		subheading?: string;
		informationText: string;
		defaultHm?: string;
		showLinksInSelectionBanner?: boolean;
	};

	defineProps<Props>();

	const componentInstanceId = useId();
	const hypermarketsStore = useStoryblokHypermarketsStore();
	const {selectedHypermarket} = storeToRefs(hypermarketsStore);
</script>
